let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2upQO")).then(() => parcelRequire('fHNg2'));